import { Common } from '../common';
import { ActiveJob } from '../models/crawlerApi/activeJobs';
import {
  CrawlerConfig,
  CreateValues,
  UpdateValues,
} from '../models/crawlerApi/config';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAllByOrganizationId(
    organizationId: string,
  ): Promise<CrawlerConfig[]> {
    const url = this.common.constructPath('/crawler/crawler-configs', {
      organizationIds: [organizationId],
    });
    const { crawlerConfigs } = await this.common.getJSON(url);
    return crawlerConfigs;
  }

  async findOneById(id: string): Promise<CrawlerConfig> {
    const url = this.common.constructPath(`/crawler/crawler-configs/${id}`);
    const { crawlerConfig } = await this.common.getJSON(url);
    return crawlerConfig;
  }

  async create(values: CreateValues): Promise<CrawlerConfig> {
    const url = this.common.constructPath('/crawler/crawler-configs');
    const { crawlerConfig } = await this.common.postJSON(url, values);
    return crawlerConfig;
  }

  async startCrawl(id: string): Promise<ActiveJob[]> {
    const url = this.common.constructPath(
      `/crawler/crawler-configs/${id}/start`,
    );
    return this.common.postJSON(url, {});
  }

  async stopCrawl(id: string): Promise<void> {
    const url = this.common.constructPath(
      `/crawler/crawler-configs/${id}/abort`,
    );
    return this.common.postJSON(url, {});
  }

  async update(id: string, values: UpdateValues): Promise<CrawlerConfig> {
    const url = this.common.constructPath(`/crawler/crawler-configs/${id}`);
    const { crawlerConfig } = await this.common.patchJSON(url, values);
    return crawlerConfig;
  }
}
